import Button from 'semantic-ui-react/dist/commonjs/elements/Button';
import '@purple/semantic-ui-family-connection-theme/components/button.css';

export default Button;
